module.exports = __webpack_public_path__ + "img/tag-fill.87089fda.svg";